module.exports = __webpack_public_path__ + "img/01.a974bc4.png";